import React from 'react';
import { SearchList } from 'components/SearchList/SearchList';

export function SearchView() {
    return (
        <div className="main_views_cont">
            <div className="search_center">
                <SearchList />
            </div>
        </div>
    );
}
